import type { InvoiceLineKind } from "@api/shared-runtime/enums";
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { groupInvoiceLines, sumLineAmounts } from "./invoice-lines";
import {
  INVOICE_LINES_SUBTOTAL_LABEL,
  SAILE_CHARGES_LABEL,
  WAGE_PASS_THROUGH_DETAIL,
} from "./wage-pass-through-copy";

type InvoiceLinesTableLine = {
  id: string;
  kind: InvoiceLineKind;
  description: string;
  amount: string;
};

export function InvoiceLinesTable({
  lines,
  totalAmount,
  descriptionHeader,
  formatAmount,
}: {
  lines: InvoiceLinesTableLine[];
  totalAmount: string;
  descriptionHeader: string;
  formatAmount: (amount: string) => string;
}) {
  const { saileLines, wageLines } = groupInvoiceLines(lines);
  const showSaileSubtotal = saileLines.length > 0 && wageLines.length > 0;
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{descriptionHeader}</TableHead>
          <TableHead className="text-right">Amount</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {saileLines.map((line) => (
          <TableRow key={line.id}>
            <TableCell>{line.description}</TableCell>
            <TableCell className="text-right tabular-nums">
              {formatAmount(line.amount)}
            </TableCell>
          </TableRow>
        ))}
        {showSaileSubtotal && (
          <TableRow>
            <TableCell className="text-muted-foreground">
              {SAILE_CHARGES_LABEL}
            </TableCell>
            <TableCell className="text-right tabular-nums text-muted-foreground">
              {formatAmount(sumLineAmounts(saileLines))}
            </TableCell>
          </TableRow>
        )}
        {wageLines.map((line) => (
          <TableRow key={line.id}>
            <TableCell>
              {line.description}
              <p className="text-xs text-muted-foreground">
                {WAGE_PASS_THROUGH_DETAIL}
              </p>
            </TableCell>
            <TableCell className="text-right tabular-nums">
              {formatAmount(line.amount)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <TableFooter>
        <TableRow>
          <TableCell className="font-semibold">
            {INVOICE_LINES_SUBTOTAL_LABEL}
          </TableCell>
          <TableCell className="text-right font-semibold tabular-nums">
            {formatAmount(totalAmount)}
          </TableCell>
        </TableRow>
      </TableFooter>
    </Table>
  );
}
